import * as React from 'react';
/**
 *
 * Original name: analytics
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=29934%3A6890
 *
 */
export const AnalyticsPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M42.575 28.01v18.937h4V28.01h-4Zm-8.878 18.937v-14.82h4v14.82h-4Zm-8.963-9.88v9.88h4v-9.88h-4Zm-8.774 3.389v6.587h4v-6.587h-4Zm25.044-19.701 2.67-4.417h4.674l-5.088 8.416h-7.653l-4.95 5.585h-8.619l-6.078 6.839v-6.021l4.282-4.818h8.615l4.95-5.584h7.197Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.595 7.604h48v48h-48v-48Zm4 4v40h40v-40h-40Z", fill: "currentColor" })));
